import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteWantedMultiProps } from './DeleteWantedMulti.types';

export const DeleteWantedMulti = ({
  checkedOwners,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteWantedMultiProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.POSZUKIWANY]?.edit;

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={<TrashIcon />}
          onClick={onModalOpen}
          disabled={isPermsDisabled}
        >
          {formatMessage({ id: AppMessages['common.delete'] })}
        </Button>
      </Tooltip>

      <ActionModal
        size="medium"
        header={formatMessage({ id: AppMessages['wanted.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['wanted.multiAction.delete.subtitle'] })} {checkedOwners.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['wanted.multiAction.delete.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
